import { validateToken } from "../../Redux/Auth/AuthActions";
import styles from "./UnauthorizedPage.module.scss";
import { AppDispatch } from "../../Redux/store";
import { useDispatch } from "react-redux";
import { Link } from "react-router";

function UnauthorizedPage() {
  const dispatch = useDispatch<AppDispatch>();

  const validateTokenHandler = () => {
    dispatch(validateToken());
  };

  return (
    <div className={styles.mainContainer}>
      <div className={styles.errorContainer}>
        <h1 className={styles.heading}>Forbidden</h1>
        <p className={styles.description}>
          You are not authrozied to view this page
        </p>
        <div className={styles.linkContainer}>
          <Link
            className={styles.link}
            to="/admin"
            onClick={validateTokenHandler}
          >
            Go to Homepage
          </Link>
        </div>
      </div>
    </div>
  );
}

export default UnauthorizedPage;
